// -----------------------------------------------------------------------------
// AIDAS Platform — main.tsx (Vite entry point)
// ✅ Wraps everything inside <BrowserRouter> to restore routing context
// ✅ Fixes "useLocation() may be used only in the context of a <Router> component"
// -----------------------------------------------------------------------------

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { AlertProvider } from "./context/AlertContext";
import SessionRevokedModal from "./components/SessionRevokedModal";
import SessionExpiryModal from "./components/SessionExpiryModal";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <NotificationProvider>
            <AlertProvider>
              <App />
              <SessionRevokedModal />
              <SessionExpiryModal />
            </AlertProvider>
          </NotificationProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
